/**
 * @file PanelItem.jsx
 * @author Daniel Aguirre
 * @description PanelItem Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

function PanelItem({
  icon,
  body,
  options,
  onClick,
  fullOnClick,
  allClickable = false
}) {
  return (
    <div
      onClick={() => (allClickable ? fullOnClick() : null)}
      style={{ border: 'solid 1px var(--color-grayBorders)' }}
      className="mb-3 py-2 px-3 rounded-md flex flex-wrap justify-between items-center">
      <div
        onClick={() => (onClick ? onClick() : null)}
        className="flex flex-row max-w-80p cursor-pointer">
        <div className="text-left flex items-center">{icon}</div>
        <div className="text-left text-baxterGray ml-2 md:ml-5 mb-0">
          {body}
        </div>
      </div>
      <div className="flex justify-end">{options}</div>
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
PanelItem.propTypes = {
  icon: PropTypes.element.isRequired,
  body: PropTypes.element.isRequired,
  options: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  fullOnClick: PropTypes.func,
  allClickable: PropTypes.bool
};
export default PanelItem;
